import { ref, onScopeDispose, getCurrentScope } from 'vue';

// The amount of time the tab needs to be hidden, (tab-loses focus, closes computer lid or minimizing) before we consider the cache stale
export const CACHE_TTL = 60 * 30 * 1000; // 30 minutes

const hiddenAt = ref(0);
const listeners = ref(new Set<(elapsed: number) => void>());
let listenerBound = false;

function ensureListener() {
  const isSSR = typeof window === 'undefined' || typeof document === 'undefined';

  if (listenerBound || isSSR) {
    return;
  }

  listenerBound = true;

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      hiddenAt.value = Date.now();
    } else if (document.visibilityState === 'visible' && hiddenAt.value > 0) {
      const elapsed = Date.now() - hiddenAt.value;
      hiddenAt.value = 0;
      for (const fn of listeners.value) fn(elapsed);
    }
  });
}

export function onTabResume(fn: (elapsed: number) => void): () => void {
  ensureListener();
  listeners.value.add(fn);
  const remove = () => listeners.value.delete(fn);

  if (getCurrentScope()) {
    onScopeDispose(remove);
  }
  return remove;
}
